<template>
	<div>
		<div class="mb-4">
			<h1 class="section-title mb-2">Chat con Lexi</h1>
			<p class="section-lead mb-0">Tu asistente legal personal</p>
		</div>

		<div class="lexi-chat-card d-flex flex-column">
			<div class="lexi-chat-header">
				<div class="d-flex align-items-center">
					<div class="lexi-avatar mr-3">
						<i class="fa-regular fa-robot"></i>
					</div>
					<div>
						<h3 class="mb-0">Lexi</h3>
						<p class="mb-0 small">Tu asistente legal</p>
					</div>
				</div>
			</div>

			<div ref="chatScroll" class="lexi-chat-body">
				<div
					v-for="(msg, index) in chatMessages"
					:key="index"
					class="d-flex mb-3"
					:class="msg.sender === 'user' ? 'justify-content-end' : 'justify-content-start'"
				>
					<div
						class="chat-bubble"
						:class="msg.sender === 'user' ? 'chat-bubble-user' : 'chat-bubble-bot'"
					>
						<p class="mb-0 small">{{ msg.text }}</p>
					</div>
				</div>
			</div>

			<div class="lexi-chat-footer">
				<b-form class="d-flex" @submit.prevent="handleSendMessage">
					<b-form-input
						v-model="chatMessage"
						placeholder="Escribe tu mensaje..."
						class="flex-grow-1 mr-2"
					></b-form-input>
					<b-button type="submit" variant="info" :disabled="!chatMessage.trim()">
						<i class="fa-regular fa-paper-plane"></i>
					</b-button>
				</b-form>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'MyAccountLexi',

	data() {
		return {
			chatMessage: '',
			chatMessages: [
				{ sender: 'lexi', text: '¡Hola! Soy Lexi, tu asistente legal. ¿En qué puedo ayudarte hoy?' },
			],
		}
	},

	methods: {
		handleSendMessage() {
			if (!this.chatMessage.trim()) return

			this.chatMessages.push({ sender: 'user', text: this.chatMessage })
			this.chatMessage = ''

			this.$nextTick(() => {
				this.scrollChatToBottom()
			})

			setTimeout(() => {
				this.chatMessages.push({
					sender: 'lexi',
					text: 'Entiendo tu consulta. Déjame buscar la mejor información para ayudarte.',
				})
				this.$nextTick(() => {
					this.scrollChatToBottom()
				})
			}, 1000)
		},

		scrollChatToBottom() {
			const el = this.$refs.chatScroll
			if (el) {
				el.scrollTop = el.scrollHeight
			}
		},
	},
}
</script>
